import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_URL } from "../config";

function NewsletterPopup() {
  const [showPopup, setShowPopup] = useState(false);
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});
  const [formLoading, setFormLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const POPUP_STORAGE_KEY = "newsletterPopupLastShown";

  const validateEmail = (email) => /^\S+@\S+\.\S+$/.test(email);

  useEffect(() => {
  const lastShown = localStorage.getItem(POPUP_STORAGE_KEY);
  const subscribed = localStorage.getItem("newsletterSubscribed");
  const now = new Date().getTime();
  const sevenDays = 7 * 24 * 60 * 60 * 1000; // 7 days

  // Only show if not subscribed AND 7 days passed
  if (!subscribed && (!lastShown || now - parseInt(lastShown) > sevenDays)) {
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 25000); // 5000ms = 5 seconds

    return () => clearTimeout(timer); // cleanup on unmount
  }
}, []);

  const handleClose = () => {
    // Mark the time it was closed
    localStorage.setItem(POPUP_STORAGE_KEY, new Date().getTime().toString());
    setShowPopup(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    setMessage("");
    setErrorMessage("");

    if (!validateEmail(email)) {
      setErrors({ email: "Please enter a valid email address." });
      return;
    }

    setFormLoading(true);
    try {
      const responseIp = await axios.get("https://api.ipify.org?format=json");
      await axios.post(`${API_URL}news-letter/create`, {
        email,
        ip: responseIp.data.ip,
      });

      // Mark as subscribed
      localStorage.setItem("newsletterSubscribed", "true");

      setEmail("");
      setMessage("Subscription successful!");
      localStorage.setItem(POPUP_STORAGE_KEY, new Date().getTime().toString());

      setTimeout(() => setShowPopup(false), 3000);
    } catch (error) {
      console.error(error);
      setErrorMessage(
        error?.response?.data?.message ||
          "Subscription failed. Please try again."
      );
    } finally {
      setFormLoading(false);
    }
  };

  if (!showPopup) return null;

  return (
    <div className="newsletter-popup-overlay">
      <div className="newsletter-popup-box">
        {/* Close button */}
        <button
          type="button"
          className="newsletter-popup-close"
          onClick={handleClose}
        >
          ×
        </button>

        <div className="newsletter-popup-icon">📷</div>
        <h2 className="newsletter-popup-title">Wait! Before You Go…</h2>
        <p className="newsletter-popup-desc">
          Don’t miss out on exclusive offers, latest product launches, and exciting
          discounts delivered directly to your inbox.
        </p>

        <form onSubmit={handleSubmit}>
          <input
            type="email"
            className={`newsletter-popup-input ${
              errors.email ? "invalid-input" : ""
            }`}
            placeholder="Enter your email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <div className="newsletter-popup-button-group">
            <button
              type="submit"
              className="newsletter-popup-button-primary"
              disabled={formLoading}
            >
              {formLoading ? "Submitting..." : "Subscribe & Stay Updated"}
            </button>
          </div>
        </form>

        {errors.email && <div className="text-danger mt-2">{errors.email}</div>}
        {message && <div className="text-success mt-2">{message}</div>}
        {errorMessage && <div className="text-danger mt-2">{errorMessage}</div>}
      </div>
    </div>
  );
}

export default NewsletterPopup;
